module.exports = __webpack_public_path__ + "0a471fab4b700b1f95445d1d0920738c.pdf";